<template>
    <div class="d-flex flex-column mt-2 card p-2">
        <span class="font-size-base fw-bold">
            {{ contactInformation.lastName }}, {{ contactInformation.firstName }}
        </span>
        <span class="mb-1 text-secondary"> NPI: {{ contactInformation.npiNumber }} </span>
        <b>Contact Information:</b>
        <span class="d-flex">
            <span class="me-1">{{ contactInformation?.address?.addressLine1 }}</span>
            <span class="me-1">{{ contactInformation?.address?.addressLine2 }}</span>
            <span class="me-1">{{ contactInformation?.address?.city }}</span>
            <span class="me-1">{{ contactInformation?.address?.state }}</span>
            <span class="me-1">{{ contactInformation?.address?.zipCode }}</span>
        </span>
        <span>
            <strong> Phone:</strong>
            <span v-for="(phoneNumber, index) of contactInformation.phoneNumbers" :key="index">
                &nbsp;{{ phoneNumber.country }}-{{ phoneNumber.number
                }}{{ index != contactInformation.phoneNumbers.length - 1 ? "," : "" }}
            </span>
        </span>
        <span>
            <strong>Fax:</strong>
            <span v-if="contactInformation.faxNumber">{{ contactInformation.faxNumber }}</span>
            <small v-else><i class="text-default">&nbsp; Not Available</i></small>
        </span>
        <span> {{ contactInformation.email }} </span>
    </div>
</template>

<script lang="ts" src="./ContactInfoCard.ts"></script>
